'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = bindActionGroups;

var _bindActionCreators = require('redux/lib/bindActionCreators');

var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bindActionGroups(actionGroups, dispatch) {

  if (typeof actionGroups === 'function' && actionGroups == null) {
    return (0, _bindActionCreators2.default)(actionGroups, dispatch);
  }

  if ((typeof actionGroups === 'undefined' ? 'undefined' : _typeof(actionGroups)) !== 'object' || actionGroups == null) {
    throw new Error('bindActionGroups expected an object, key is group name, value is object with actionCreators');
  }

  var groupActionCreators = {};
  var groupKeys = Object.keys(actionGroups);

  for (var i = 0; i < groupKeys.length; i++) {
    var key = groupKeys[i];
    var actionCreators = actionGroups[key];
    if (((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) === 'object' || typeof actionCreators === 'function') && actionCreators) {
      groupActionCreators[key] = (0, _bindActionCreators2.default)(actionCreators, dispatch);
    }
  }

  return groupActionCreators;
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-bind-action-groups/lib/index.js
// module id = 3542
// module chunks = 4